<template>
  <section>
    <div class="row q-gutter-sm col-12 items-center q-mt-md">
      <div class="col-2">
        <ListaUnidadesSelect />
      </div>
      <div class="col-2">
        <q-file label="Selecione o Template" outlined dense v-model="file">
          <template v-slot:prepend>
            <q-icon name="attach_file" />
          </template>
        </q-file>
      </div>

      <div class="col-2">
        <q-btn
          color="positive"
          label="Enviar Template"
          icon="file_upload"
          no-caps
          @click="enviarTemplate"
        />
      </div>
    </div>
  </section>
</template>

<script>
import { ref } from "@vue/reactivity";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";

export default {
  components: {
    ListaUnidadesSelect,
  },
  props: {
    mapeamento: {
      type: String,
    },
    link: {
      type: String,
    },
    title: {
      type: String,
    },
    termo: {
      type: String,
    },
    adicional: {
      type: Array,
    },
  },
  setup(props) {
    const quasar = useQuasar();
    const store = useStore();
    const file = ref("");

    const enviarTemplate = async () => {
      if (file.value == "" || file.value.name.indexOf("xlsx") == -1) {
        quasar.notify({
          message: "O tipo do arquivo não e aceito, ou o campo esta vazio",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }

      try {
        var reader = new FileReader();
        reader.readAsDataURL(file.value);
        reader.onload = async function () {
          try {
            await store.dispatch("grupoProdutos/uploads", {
              planilha: reader.result,
              mapeamento: props.mapeamento,
              unidade: store.state.org.unidadeData.id,
            });

            quasar.notify({
              message: "Usuario criado com sucesso",
              color: "positive",
              actions: [
                {
                  label: "Fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
          } catch (error) {
            const mensagem =
              error?.response?.data?.message ||
              error?.message ||
              "Erro ao enviar o template";

            quasar.notify({
              message: mensagem,
              color: "negative",
              actions: [
                {
                  label: "Fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
          }
        };

        file.value = "";
      } catch (error) {
        console.log(error);

        file.value = "";
      }
    };

    return {
      enviarTemplate,
      file,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
</style>
